import * as apiService from './api';

class NotificationService {
  /**
   * Get user's notifications with pagination and filtering
   * @param {Object} params - Query parameters
   * @returns {Promise<Object>}
   */
  async getNotifications(params = {}) {
    const API_URL = `${process.env.REACT_APP_API_URL}/api`;
    const token_value =
      localStorage.getItem('token') || sessionStorage.getItem('token');

    const queryParams = new URLSearchParams({
      limit: params.limit || 20,
      offset: params.offset || 0,
      ...params,
    });

    try {
      const response = await fetch(
        `${API_URL}/notifications?${queryParams.toString()}`,
        {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token_value,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching notifications:', error);
      throw error;
    }
  }

  /**
   * Get unread notification count
   * @returns {Promise<number>}
   */
  async getUnreadCount() {
    const API_URL = `${process.env.REACT_APP_API_URL}/api`;
    const token_value =
      localStorage.getItem('token') || sessionStorage.getItem('token');

    try {
      const response = await fetch(`${API_URL}/notifications/unread-count`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token_value,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();
      return data.unreadCount || data.count || 0;
    } catch (error) {
      console.error('Error fetching unread count:', error);
      return 0;
    }
  }

  /**
   * Mark a notification as read
   * @param {string} notificationId
   * @returns {Promise<Object>}
   */
  async markAsRead(notificationId) {
    const API_URL = `${process.env.REACT_APP_API_URL}/api`;
    const token_value =
      localStorage.getItem('token') || sessionStorage.getItem('token');

    try {
      const response = await fetch(
        `${API_URL}/notifications/${notificationId}/read`,
        {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token_value,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error marking notification as read:', error);
      throw error;
    }
  }

  /**
   * Mark all notifications as read
   * @returns {Promise<Object>}
   */
  async markAllAsRead() {
    const API_URL = `${process.env.REACT_APP_API_URL}/api`;
    const token_value =
      localStorage.getItem('token') || sessionStorage.getItem('token');

    try {
      const response = await fetch(`${API_URL}/notifications/mark-all-read`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token_value,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error marking all notifications as read:', error);
      throw error;
    }
  }

  /**
   * Delete a notification
   * @param {string} notificationId
   * @returns {Promise<Object>}
   */
  async deleteNotification(notificationId) {
    const API_URL = `${process.env.REACT_APP_API_URL}/api`;
    const token_value =
      localStorage.getItem('token') || sessionStorage.getItem('token');

    try {
      const response = await fetch(
        `${API_URL}/notifications/${notificationId}`,
        {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            'x-auth-token': token_value,
          },
        }
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error deleting notification:', error);
      throw error;
    }
  }

  /**
   * Get notification stats
   * @returns {Promise<Object>}
   */
  async getStats() {
    const API_URL = `${process.env.REACT_APP_API_URL}/api`;
    const token_value =
      localStorage.getItem('token') || sessionStorage.getItem('token');

    try {
      const response = await fetch(`${API_URL}/notifications/stats`, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          'x-auth-token': token_value,
        },
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error('Error fetching notification stats:', error);
      throw error;
    }
  }
}

// Export singleton instance
export default new NotificationService();
